import $ from 'jquery';
import Player from "@vimeo/player";

export default () => {
    $('.player-video__item').on('click', function () {
        $("#modal-show-video").modal('show');
    });

    var iframe_video_visual = document.getElementById('player-iframe');
    if (iframe_video_visual !== null) {
        if (iframe_video_visual.nodeName === 'IFRAME' && iframe_video_visual.getAttribute('src') !== null && iframe_video_visual.getAttribute('src') !== '' && iframe_video_visual.getAttribute('src') !== undefined) {
            var player_video = new Player(iframe_video_visual);
            var $modal = $("#modal-show-video");

            player_video.pause();

            $modal.on('shown.bs.modal', function () {
                $('body').addClass('overflow-hidden');
                if ($(window).width() > 768) {
                    player_video.play();
                }
            });
            
            $modal.on('hide.bs.modal', function () {
                $('body').removeClass('overflow-hidden');
                player_video.pause();
            });
        }
    }
};



// WEBPACK FOOTER //
// ./scripts/libs/player-video.js